'use client';

import { usePathname } from 'next/navigation';
import type { ReactNode } from 'react';
import { isSignalRoute } from '@/lib/signal/site';

/**
 * The site's frame and its bar, left off the Signal pages, which draw their own. Decided on the
 * client so a tap between the two kinds of page swaps the frame too; the root layout never
 * re-renders on a client navigation.
 */
export function SiteChrome({ bar, children }: { bar: ReactNode; children: ReactNode }) {
  if (isSignalRoute(usePathname())) return children;
  return (
    <>
      <main className="relative min-h-screen flex flex-col px-4 sm:px-6">
        <div className="w-full max-w-7xl mx-auto flex-1 flex flex-col">{children}</div>
      </main>
      {bar}
    </>
  );
}
